import React from "react";
import Input from "@/scenes/demo/components/input";
import { useGenericContext } from "@/context/generic";
import Section from "@/scenes/demo/components/section";
import ThankYou from "@/scenes/demo/components/thank-you";

const Sections = (props) => {
    const context = useGenericContext();
    const { state } = context;
    let index = 0;

    return (
        <div className="questions">
            <Section index={index++}>
                <h1 className="">
                    Velkommen til Mekle
                </h1>
                <h4>
                    Svar på noen spørsmål om kravet som er bestridt, så vil vi håndtere saken videre.
                </h4>

                <Input className="mt-4" {...{
                    pkey: "business_name",
                    label: "Hva er navnet på virksomheten du representerer?",
                    description: "Fyll inn navnet på virksomheten som du svarer på spørsmål på vegne av.",
                    type: "string",
                    placeholder: "Tast navnet her",
                }}/>

                <h3 className="mt-6">
                    Kontaktperson
                </h3>

                <Input className="mt-4" {...{
                    pkey: "contact_name",
                    label: "Ditt navn",
                    type: "string",
                    placeholder: "Ola Nordmann",
                }}/>

                <div className="group mt-4 gg-3">
                    <Input className="" {...{
                        pkey: "contact_email",
                        label: "E-post",
                        placeholder: "ola@nordmann.as",
                        type: "string",
                    }}/>

                    <Input className="" {...{
                        pkey: "contact_phone",
                        label: "Telefonnummer",
                        placeholder: "99 99 99 99",
                        type: "string",
                    }}/>
                </div>
            </Section>

            <Section index={index++}>
                <h2>
                    Om kravet
                </h2>

                <Input index={index} className="mt-4" {...{
                    pkey: "sum",
                    label: "Skriv inn summen/størrelsen på kravet/faktura som er bestridt",
                    type: "string",
                    placeholder: "Skriv inn totalbeløpet som er bestridt i NOK",
                }}/>

                <Input index={index} className="mt-4" {...{
                    pkey: "reason",
                    label: "Hvorfor har motpart (debitor) bestridt kravet?",
                    description: "Som regel har debitor en begrunnelse for hvorfor kravet ikke er betalt. Dette kan for eksempel være uenighet om hva som ble avtalt, manglende kvalitet i leveransen, feil og mangler etc.",
                    type: "text",
                    placeholder: "Beskriv debitor sin begrunnelse for hvorfor kravet er bestridt",
                }}/>

                <h3 className="mt-6">
                    Motparten
                </h3>

                <Input index={index} className="mt-4" {...{
                    label: "Har du kontaktinfo til motpart (debitor)?",
                    description: "Vi vil ikke ta kontakt med motpart før vi har hatt dialog og avklart med deg.",
                    pkey: "has_contact_info",
                    type: "boolean",
                    triggerOnSelect: true,
                    options: [
                        {
                            label: "Ja",
                            value: true,
                        },
                        {
                            label: "Nei",
                            value: false,
                        },
                    ],
                }}/>

                <div className={ state?.funnel?.has_contact_info?.value ? "" : "disabled" }>
                    <Input className="mt-4" {...{
                        pkey: "part_name",
                        label: "Navn på motpart",
                        type: "string",
                        placeholder: "Ola Nordmann AS",
                    }}/>

                    <div className="group mt-4 gg-3">
                        <Input className="" {...{
                            pkey: "part_email",
                            label: "Epost til motpart",
                            placeholder: "ola@nordmann.as",
                            type: "string",
                        }}/>

                        <Input className="" {...{
                            pkey: "part_phone",
                            label: "Telefon til motpart",
                            placeholder: "99 99 99 99",
                            type: "string",
                        }}/>
                    </div>
                </div>
            </Section>

            <Section index={index++}>
                <h2>
                    Det var det!
                </h2>

                <p>
                    Men før du sender inn, hvordan hørte du om oss?
                </p>

                <Input className="mt-4" {...{
                    pkey: "where_did_you_find_us",
                    type: "dropdown",
                    options: [
                        {
                            label: "Velg fra listen",
                        },
                        {
                            label: "Axactor",
                            id: "Axactor",
                        },
                        {
                            label: "Kredin",
                            id: "Kredin",
                        },
                        {
                            label: "Azets",
                            id: "Azets",
                        },
                        {
                            label: "Kravia",
                            id: "Kravia",
                        },
                        {
                            label: "Ikke på listen",
                            id: "Ikke på listen",
                        },
                    ],
                }}/>

                <div className="sm-hidden md-hidden">
                    <div className="mx-a mt-7" style={{ width: "300px" }}>
                        <img
                            src="/static/images/both-parties-heard.webp"
                            style={{ width: "300px", height: "300px" }}
                            alt="Begge parter blir hørt"
                        />
                    </div>
                </div>

                <div className="xs-hidden lg-hidden">
                    <div className="mx-a mt-10" style={{ width: "250px" }}>
                        <img
                            src="/static/images/both-parties-heard.webp"
                            style={{ width: "250px", height: "250px" }}
                            alt="Begge parter blir hørt"
                        />
                    </div>
                </div>

                <div className="xs-show md-hidden lg-hidden">
                    <div className="mx-a" style={{ width: "250px" }}>
                        <img
                            src="/static/images/both-parties-heard.webp"
                            style={{ width: "250px", height: "250px" }}
                            alt="Begge parter blir hørt"
                        />
                    </div>
                </div>
            </Section>

            <Section index={index++}/>
            <Section index={index++}>
                <ThankYou/>
            </Section>
        </div>
    );
};

export default Sections;
